module.exports = __webpack_public_path__ + "static/speaker5-a0e327a841d25124c273f84d13e710ae.jpg";